import { Component, OnInit, effect, inject, input, ChangeDetectionStrategy } from '@angular/core';

import {
  deviceAllowedToAssign,
  deviceAllowedToMarkAsSpare,
  deviceAllowedToMarkUnavailable,
  deviceAllowedToUnassign,
} from '@era/stores';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { environment } from '@rocksoft/environment';
import { Device, DeviceActionBarComponent } from '@rocksoft/shared';
import { AssignmentHistoryModalComponent } from '../../sub-features/device-assignment/assignment-history/assignment-history-component/assignment-history-modal.container';
import { NotesModalComponent } from '../../sub-features/device-notes/notes-modal/notes-modal.container';

@Component({
  selector: 'era-device-action-bar',
  templateUrl: './device-action-bar.container.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [DeviceActionBarComponent],
})
export class DeviceActionBarContainerComponent implements OnInit {
  private readonly modalService = inject(NgbModal);

  public allowUnassign: boolean;
  public allowUnavailable: boolean;
  public allowAssign: boolean;
  public allowSpare: boolean;
  public readonly device = input.required<Device>();
  public readonly notesEnabled: boolean = environment.features.devices.notes.enabled;
  public readonly assignmentHistoryEnabled: boolean = environment.features.devices.assignmentHistory.enabled;

  constructor() {
    effect(() => {
      const device = this.device();
      this.recalculate(device);
    });
  }

  ngOnInit(): void {
    this.recalculate(this.device());
  }

  private recalculate(device: Device) {
    this.allowUnassign = deviceAllowedToUnassign(device);

    this.allowUnavailable = deviceAllowedToMarkUnavailable(device);

    this.allowSpare = deviceAllowedToMarkAsSpare(device);

    this.allowAssign = deviceAllowedToAssign(device);
  }

  openNotesModal() {
    this.modalService.open(NotesModalComponent, { backdrop: 'static', centered: true, size: 'lg', scrollable: true });
  }

  openAssignmentHistoryModal() {
    this.modalService.open(AssignmentHistoryModalComponent, {
      backdrop: 'static',
      centered: true,
      size: 'lg',
      scrollable: true,
    });
  }
}
